<template>
  <div>
    <div v-if="isLoading" class="py-5 text-center"><b-spinner/></div>
    <b-form v-else @submit.prevent="submitForm">
      <b-form-group :label="$t('emailSubject')">
        <b-form-input type="text" readonly v-model="subject" class="bg-transparent"></b-form-input>
      </b-form-group>
      <b-form-group :label="$t('emailContent')">
        <ckeditor :editor="editor" v-model="content" :config="editorConfig" disabled></ckeditor>
      </b-form-group>
      <b-form-checkbox v-model="sendSms">{{ $t("sendSms") }}</b-form-checkbox>
      <div v-if="errorMsg" class="text-danger mb-4">{{ $t(errorMsg) }}</div>
      <div class="text-center">
        <b-button type="submit" variant="primary" :disabled="isSubmitting">
          {{ sendSms? $t("sendEmailAndSms") : $t("sendEmail") }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as meetingService from "@/service/meetingService";
  import * as utils from "@/service/util";

  @Component
  export default class SendMeetingEmailConfirmModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;
    @Prop({ required: true }) meetingId: number;
    @Prop({ required: true }) status: string;

    editor = null;
    editorConfig = {
      toolbar: []
    };

    isLoading = true;
    subject = "";
    content = "";
    sendSms = false;

    errorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {
      this.fetchEmail();
    }

    async fetchEmail() {
      try {
        this.isLoading = true;
        this.editor = await utils.loadCkeditor();
        const { subject, content } = await meetingService.getPreviewMeetingEmail(this.meetingId, this.status);
        this.subject = subject;
        this.content = content;

      } catch (e) {
        console.error(e);
        this.errorMsg = e.response?.data?.code || e.code;

      } finally {
        this.isLoading = false;
      }
    }

    async submitForm() {
      try {
        this.isSubmitting = true;
        await meetingService.sendNotificationEmails(this.meetingId, this.status);
        this.toastSuccessDelay(this.$t("sendEmailSuccessful").toString());

        if (this.sendSms) {
          await meetingService.sendInvitationSms(this.meetingId, 0);
          this.toastSuccessDelay(this.$t("sendSmsSuccessful").toString());
        }

        this.$bvModal.hide(this.modalId);
        this.__submitted();

      } catch (e) {
        console.error(e);
        this.errorMsg = e.response?.data?.code || e.code;

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
